import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ConnectionState } from 'app/shared/enums/connection-state.enum';

import { RealTimeEvent } from './real-time-event.model';

export const MESSAGE_BUS_SERVICE = new InjectionToken<MessageBusService>('MESSAGE_BUS_SERVICE');

export interface MessageBusService {

  instanceId$: Observable<string | null>;
  connectionState$: Observable<ConnectionState>;

  /**
     * @param channel
     */
  disconnect(channel: string): void;

  /**
     * It subscribe to a channel to receive real time events
     * @param channel Channel to subscribe
     */
  connect(channel: string, action?: string, reconnectObservable?: Observable<any> | null): Observable<RealTimeEvent>;
  /**
     * It sends a real time event to the channel specified
     * @param message message to send
     * @param channel channel to send
     */
  send(message: RealTimeEvent, channel: string): Observable<void>;
}
